import { FunctionComponent } from 'react';
import { SearchIndexCourseResult } from '../../../../services/search/searchEducator';
import styles from './styles.module.scss';
import { CourseRow } from '../../../CourseRow';
import { VatSettings } from '@shared/types';

type RowsProps = {
    courses: SearchIndexCourseResult['results'];
    showPricing?: boolean;
    vatSettings?: VatSettings;
};

export const Rows: FunctionComponent<RowsProps> = ({
    courses,
    showPricing = true,
    vatSettings,
}) => {
    return (
        <ul className={styles.courseRows}>
            {courses.map((courses) => {
                return (
                    <li key={courses._id}>
                        <CourseRow
                            course={courses}
                            showPricing={showPricing}
                            vatSettings={vatSettings}
                        />
                    </li>
                );
            })}
        </ul>
    );
};
